import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Typography from '@material-ui/core/Typography';
import GetAppIcon from '@material-ui/icons/GetApp';



export class Report extends Component {

    //constructor(props) {
    //    super(props);
    //    this.state = {
    //        mqFileDownload: "",
    //        mrFileDownload: ""
    //    };

    //    console.log("mqFile: " + this.props.mqFile);
    //    if (this.props.mqFile !== undefined) {
    //        this.setState({ mqFileDownload: "/api/FileUploadDownload/DownloadFileId/" + localStorage.getItem("authtoken") + "/" + this.props.mqFile });
    //    }

    //    console.log("mrFile: " + this.props.mrFile);
    //    if (this.props.mrFile !== undefined) {
    //        this.setState({ mrFileDownload: "/api/FileUploadDownload/DownloadFileId/" + localStorage.getItem("authtoken") + "/" + this.props.mrFile });
    //    }
    //}

    render() {
        const {
            title,
            mqFile,
            mrFile,
            nsFile,
            nwFile,
            additionalFile,
            comment,
            actualDate,
            plannedDate,
            isApprovedQC
        } = this.props;

        //console.log("mqFile: " + mqFile);

        var tagFileMqDisabled;
        if (mqFile === null) {
            tagFileMqDisabled = true;
        } else {
            tagFileMqDisabled = false;
        }

        var tagFileMrDisabled;
        if (mrFile === null) {
            tagFileMrDisabled = true;
        } else {
            tagFileMrDisabled = false;
        }

        var tagFileNsDisabled;
        if (nsFile === null) {
            tagFileNsDisabled = true;
        } else {
            tagFileNsDisabled = false;
        }

        var tagFileNwDisabled;
        if (nwFile === null) {
            tagFileNwDisabled = true;
        } else {
            tagFileNwDisabled = false;
        }

        var tagFileAdditionalDisabled;
        if (additionalFile === null) {
            tagFileAdditionalDisabled = true;
        } else {
            tagFileAdditionalDisabled = false;
        }

        var titleToPrint = "";

        if (isApprovedQC) {
            titleToPrint = title + " - QC Approved";
        } else {
            titleToPrint = title;
        }

        return (
            <div>
                <Card>
                    <Grid item xs={12} sm container className="romis-card-header" style={{ padding: 10 }}>
                        <Grid item xs container direction="column" spacing={2}>
                            <Grid item xs>

                                <Typography variant="h5" component="h5" gutterBottom>
                                    {titleToPrint}
                                </Typography>

                            </Grid>
                        </Grid>
                        <Grid item>

                            <Typography className="clr-gray-2" variant="caption"><strong>Actual Date:</strong> {actualDate}</Typography>
                            <Typography variant="caption"> </Typography>
                            {
                                //<Typography className="clr-gray-2" variant="caption"><strong>Planned Date:</strong> {plannedDate}</Typography>
                            }

                        </Grid>
                    </Grid>
                    <CardContent>
                        <Grid container spacing={3} >
                            <Grid item style={{ marginTop: 15 }}>
                                <Grid item style={{ display: tagFileMqDisabled ? "none" : "block" }}>
                                    <Button variant="outlined" color="primary" size="large" component="a" href={mqFile} download fullWidth disabled={tagFileMqDisabled}>
                                        <GetAppIcon style={{ paddingRight: "8px" }} /> MQ DOWLOAD
								    </Button>
                                </Grid>
                                {
                                    //<Grid item className="mt-1" style={{ marginTop: "15px" }} >
                                }
                                <Grid item style={{ marginTop: "15px", display: tagFileMrDisabled ? "none" : "block" }} >
                                    <Button variant="outlined" color="primary" size="large" component="a" href={mrFile} download fullWidth disabled={tagFileMrDisabled}>
                                        <GetAppIcon style={{ paddingRight: "8px" }} /> MR DOWLOAD
								    </Button>
                                </Grid>
                                <Grid item style={{ marginTop: "15px", display: tagFileNsDisabled ? "none" : "block" }} >
                                    <Button variant="outlined" color="primary" size="large" component="a" href={nsFile} download fullWidth disabled={tagFileNsDisabled}>
                                        <GetAppIcon style={{ paddingRight: "8px" }} /> NS DOWLOAD
								    </Button>
                                </Grid>
                                <Grid item style={{ marginTop: "15px", display: tagFileNwDisabled ? "none" : "block" }} >
                                    <Button variant="outlined" color="primary" size="large" component="a" href={nwFile} download fullWidth disabled={tagFileNwDisabled}>
                                        <GetAppIcon style={{ paddingRight: "8px" }} /> NW DOWLOAD
								    </Button>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm container>

                                <Grid item xs container direction="column" spacing={2}>
                                    <Typography variant="subtitle2">
                                        <strong>Comment</strong>
                                    </Typography>
                                    {
                                        //<TextareaAutosize
                                        //    rowsMax={6}
                                        //    value={comment}
                                        //    inputprops={{
                                        //        readOnly: true,
                                        //    }} />
                                    }
                                    <span style={{
                                        background: "#f5f5f5", padding: "10px",
                                        fontWeight: "300", borderRadius: "4px",
                                        minHeight: "105px", fontSize: "14px",
                                        maxHeight: "250px", overflowY: "auto"
                                    }}>
                                        {comment}
                                    </span>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Grid item>
                                    <Button variant="outlined" color="primary" size="large" component="a" href={additionalFile} download fullWidth disabled={tagFileAdditionalDisabled}>
                                        <GetAppIcon style={{ paddingRight: "8px" }} /> Additional File
								    </Button>
                                </Grid>
                            </Grid>

                        </Grid>
                    </CardContent>
                </Card>

                <span>
                    <img src="/images/down_arrow.png" alt="" width="50" height="50" style={{ marginTop: "30px", marginBottom: "-10px" }} />
                </span>

            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/Report.js